import { Col } from "antd";
import React, { useImperativeHandle, useRef } from "react";
import { HowItWorksStepMobile, LinkToSamll, StepsDescription, StepsDescriptionMobile, StepsMainHeadMobile, StepsTitleMobile } from "../../Epics/Grants/Pages/HowItWorks/styles";
import { replaceAnchorWithLink } from "../../utils/commonUtil";
import LeafList from "../LeafList";
import { AccordionWrapper, StepCountWrapper, StepsCount, StepsMainHead, StepsTitle, TimeLineAccordionHeading } from "./styles";

export default ({ stepCount, step, howItWorksDetails,mobile=false }) => (
  <>
    <TimeLineAccordionHeading
      dangerouslySetInnerHTML={{
        __html: howItWorksDetails[`field_step_${stepCount}_q_${step}`]
      }}
    />
    <LeafList
      howItWorksDetails={howItWorksDetails}
      stepCount={stepCount}
      step={step}
      isMobile = {mobile}
    />
  </>
);

export const GetStepCount = ({ stepCount, mobile = false }) => {
  if (!mobile) {
    return (
      <StepCountWrapper>
        <StepsCount>{stepCount}</StepsCount>
      </StepCountWrapper>
    );
  } else {
    return (
      <Col>
        <HowItWorksStepMobile>
          <StepsCount>{stepCount}</StepsCount>
        </HowItWorksStepMobile>
      </Col>
    );
  }
};

export const AccordionWrapperStep = React.forwardRef(
  (
    { expand, stepCount, howItWorksDetails, triggerScrollToTOp, mobile=false },
    ref
  ) => {
    const subTitle = `Step${stepCount} ${
      howItWorksDetails[`field_step_${stepCount}_title`]
    }`;
    const collapseFocusX = useRef();
    useImperativeHandle(ref, () => ({
      get getOffsetTop() {
        return collapseFocusX.current?collapseFocusX.current.offsetParent.offsetParent.offsetTop:null
      }
    }));

    return (
      <AccordionWrapper
        data-test={
          mobile ? "grantStepMobileAccordian" : "GrantStepWebAccordian"
        }
        onClick={() => {
          triggerScrollToTOp(!expand, subTitle);
        }}
      >
        {mobile ? (
          <>
            <StepsTitleMobile>Step {stepCount}</StepsTitleMobile>
            <StepsMainHeadMobile
              dangerouslySetInnerHTML={{
                __html: howItWorksDetails[`field_step_${stepCount}_title`]
              }}
            ></StepsMainHeadMobile>
          </>
        ) : (
          <>
            <StepsTitle>Step {stepCount}</StepsTitle>
            <StepsMainHead
              dangerouslySetInnerHTML={{
                __html: howItWorksDetails[`field_step_${stepCount}_title`]
              }}
            />
          </>
        )}

        {!mobile && stepCount === 2 ? (
          <StepsDescription
            id={"stepDescription" + stepCount}
            ref={collapseFocusX}
          >
            {howItWorksDetails &&
              replaceAnchorWithLink(
                howItWorksDetails[`field_step_${stepCount}_description`],
                "link",
                "",
                "Recommend a grant"
              ).map((item, index) => {
                if (typeof item === "string") {
                  return (
                    <span
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    ></span>
                  );
                } else {
                  return (
                    <LinkToSamll key={index} id="anrLinkToSmall">
                      {item}
                    </LinkToSamll>
                  );
                }
              })}
          </StepsDescription>
        ) : mobile ? (
          <StepsDescriptionMobile
            id={"stepDescriptionMobile" + stepCount}
            ref={collapseFocusX}
            dangerouslySetInnerHTML={{
              __html: howItWorksDetails[
                `field_step_${stepCount}_description`
              ]
            }}
          ></StepsDescriptionMobile>
        ) : (
          <StepsDescription
            id={"stepDescription" + stepCount}
            ref={collapseFocusX}
            dangerouslySetInnerHTML={{
              __html: howItWorksDetails[`field_step_${stepCount}_description`]
            }}
          />
        )}
      </AccordionWrapper>
    );
  }
);
